import store from "@/plugins/store";
import moment from 'moment';

function Receipt() {
	this.id = 0;
	this.employee = {id:0};
	this.desc = "";
	// this.date = new Date();
	this.date = null;
	this.currency = {id:0};
	this.thumbnail = "";
	this.image = "";
	this.ocr = "";
	// this.value = 0.0;
	this.value = null;
	this.has_tax = true;
	this._job = null;
	this.phase = null;
	this.kind = null;

	Object.defineProperty(this, 'job', {
		get() {
			return this._job;
		},

		set(job) {
			if (job) {
				if (this._job) {
					if (this._job.id == job.id) {
						// we're good
						return; 
					}
				}
				// console.log(job);

				// copy what we have
				this._job = {
					id: job.id,
					code: job.code,
					display_name: job.display_name,
					currency_id: 0,
				};

				// now load to get the rest
				axios
					.get("/api/jobs/" + job.id, {
						headers: {
							"Authorization": "Bearer " + store.state.token,
							"Accept": "application/json"
						}
					})
					.then(d => {
						let json = d.data;

						if (json.status == 'OK') {
							let job = json.data;

							this._job = {
								id: job.id,
								code: job.code,
								display_name: job.display_name,
								currency_id: job.currency.id,
							};

						} else {
							// TODO figure out a way to do error handling here
							console.log(json.reason);
						}
					})
					.catch(e => {
						// TODO figure out a way to do error handling here
						console.log(e.message)
					})
			} else {
				this._job = null;
			}
		}
	})

	this.set = function(receipt) {
		this.id = receipt.id;
		this.employee = receipt.employee;
		this.desc = receipt.desc;
		// this.date = new Date(receipt.date);
		this.date = receipt.date;
		this.currency = receipt.currency;
		this.thumbnail = receipt.thumbnail;
		this.image = receipt.image;
		this.ocr = receipt.ocr;
		this.value = receipt.value;
		this.has_tax = receipt.has_tax;
		if (receipt.job) {
			// console.log(receipt.job);
			this._job = {
				id: receipt.job.id,
				code: receipt.job.code,
				display_name: receipt.job.display_name,
				currency_id: receipt.job.currency.id
			}
		} else {
			this._job = null;
		}
		this.phase = receipt.phase;
		this.kind = receipt.kind;
	}

	this.list = function(employees = "", mode = 0, ignore_siid = 0) {
		return new Promise((resolve, reject) => {
			// build our url parameters
			let params = new Array();

			employees = "" + employees; // make sure this is a string
			if (employees.length > 0) {
				params.push("employees=" + employees);
			}
			if (mode > 0) {
				params.push("mode=" + mode);
			}
			if (ignore_siid > 0) {
				params.push("ignore_siid=" + ignore_siid);
			}

			// build our url, we have to add url escaping here!
			let url = "/api/expenses/receipts";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			// console.log(url);

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					if (json.status == "OK") {
						// here we return our data instead of updateing our internal state
						resolve(json.data);
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					reject(e.message);
				});
		});
	}

	this.load = function(receipt_id) {
		let self = this; // make sure we can access this inside of our promisses

		return new Promise((resolve, reject) => {
			// build our url parameters
			let params = new Array();
			

			// build our url, we have to add url escaping here!
			let url = "/api/expenses/receipts/" + receipt_id;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					reject(e.message);
				});
		});
	};

	this._dataURItoBlob = function(dataURI) {
		// https://stackoverflow.com/questions/6850276/how-to-convert-dataurl-to-file-object-in-javascript
		// convert base64 to raw binary data held in a string
		// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
		var byteString = atob(dataURI.split(',')[1]);

		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

		// write the bytes of the string to an ArrayBuffer
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}

		return new Blob([ab], {type: mimeString});
	}

	this.allow_tax = function() {
		if (this.job) {
			if (this.job.currency_id == this.currency.id) {
				return true;
			}
		}

		return false;
	}

	// upload our image and create a new receipt from it (can handle larger images)
	this.create = function(image_data) {
		let self = this;

		return new Promise((resolve, reject) => {
			let url = "/api/expenses/receipts";

			let blob = this._dataURItoBlob(image_data);
			console.log('file-after-size:', blob.size /1024, 'kb');

			axios
				.post(url, blob, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// this is the result of the last search we've started, lets process it.
					let json = d.data;

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve(json.data);
					} else {
						console.log(json.reason);
						reject(json.reason);
					}
				})
				.catch(function(e) {
					// this is the error for the last search we've started, lets show it.
					console.log(e);
					reject(e.message);
				})

		})
	}

	this.update = function() {
		let self = this;

		return new Promise((resolve, reject) => {

			// build our url parameters
			let params = new Array();

			// build our url, we have to add url escaping here!
			let url = "/api/expenses/receipts/" + self.id;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			let job_id = null;
			if (self.job) {
				if (self.job.id != 0) {
					job_id = self.job.id;
				}
			}

			let phase_id = null;
			if (self.phase) {
				if (self.phase.id != 0) {
					phase_id = self.phase.id;
				}
			}

			let kind_id = null;
			if (self.kind) {
				if (self.kind.id != 0) {
					kind_id = self.kind.id;
				}
			}

			axios
				.put(url, {
					id:self.id,
					employee_id:self.employee.id,
					desc:self.desc,
					date:moment(self.date).format("YYYY-MM-DD"),
					currency_id:self.currency.id,
					value:1.0 * self.value, /* can have become a string so convert to numeric */
					has_tax:self.has_tax ? 1 : 0, /* seems it doesn't support boolean here */
					/* image:self.image - we don't update the image */
					job_id: job_id,
					phase_id: phase_id,
					kind_id: kind_id
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// this is the result of the last search we've started, lets process it.
					let json = d.data;

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					reject(e.message);
				});	
		});
	}	

	this.delete = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			axios
				.delete("/api/expenses/receipts/" + self.id, {
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// Don't ask me why it does work here... 
					let json = d.data;
					
					if (json.status == "OK") {
						// self.set(json.data);
						resolve();
					} else {
						console.log(json.reason);
						reject(json.reason);
					}
				})
				.catch(function(e) {
					console.log(e);
					reject(e.message);
				})

		})
		
	};
}

export default Receipt;